import { BsSearch, BsArrowRepeat, BsEye } from "react-icons/bs";
import { useState, useEffect } from "react";
import Restock from "./Restock";
import { TiInfo } from "react-icons/ti";
import { FaPercentage } from "react-icons/fa";
import { Search, Filter, Plus, RefreshCw, BarChart3, Eye, AlertTriangle, Package, ChevronDown, X } from "lucide-react";
import RestockOverlay from "./RestockNI";
import { computeProductQuantity } from "./StockDetails";

export const ProductRow = ({ updateSelectedProduct, viewStockDtails, product, refreshData, user }) => {
  const [restockModal, setRestockModal] = useState(false);
  const [quantity, setQuantity] = useState("");

  useEffect(() => {
    const quantityAvailable = computeProductQuantity(product);
    setQuantity(quantityAvailable);
  }, [product]);

  let placeholderImage = "https://res.cloudinary.com/ebuka1122/image/upload/v1746897856/static%20images%20storelens/download_bvjych.png";
  let imageUrl =
    product.productImage && product.productImage.length > 0
      ? `${product?.productImage[0]?.split("/upload/")[0]}/upload/f_auto,q_auto,w_56/${product.productImage[0].split("/upload/")[1]}`
      : placeholderImage;
  return (
    <>
      <tr
        onClick={() => {
          updateSelectedProduct(product);
          viewStockDtails("stockDetails");
        }}
        className='stock-table-row '
      >
        <td className='stock-table-cell stock-cell-picture'>
          <img loading='lazy' className='stockImageSP' src={imageUrl ? imageUrl : ""} />
        </td>
        <td className='stock-table-cell stock-cell-name'>{product.name}</td>
        <td className='stock-table-cell stock-cell-brand'>{product.brand}</td>
        <td className='stock-table-cell stock-cell-price'>
          {user.userCountryCurrencySymbol} {product.unitPrice.toLocaleString()}
        </td>
        <td className='stock-table-cell stock-cell-discount'>
          {user.userCountryCurrencySymbol} {product.discountPrice ? product.discountPrice.toLocaleString() : 0}{" "}
          {product.discountPrice ? <FaPercentage size={12} /> : ""}
        </td>
        <td className='stock-table-cell stock-cell-sold'>{product.soldAmountAllTime ? product.soldAmountAllTime.toLocaleString() : 0}</td>
        <td className='stock-table-cell stock-cell-available'>
          <span
            className={`stock-availability ${
              product.quantity - product.damagedAmount <= product.stockLimit
                ? "stock-out-of-stock"
                : product.quantity - product.damagedAmount < 50
                ? "stock-low-stock"
                : "stock-in-stock"
            }`}
          >
            {product.damagedAmount ? (quantity - product.damagedAmount).toLocaleString() : quantity.toLocaleString()}
            {Number(product.quantity - product.damagedAmount) === 0 && <AlertTriangle size={14} />}
          </span>
        </td>
        <td
          onClick={(e) => {
            e.stopPropagation();
            setRestockModal(true);
          }}
          className='stock-table-cell stock-cell-actions'
        >
          <div className='stock-action-buttons'>
            <button className='stock-restock-btn' title='Restock'>
              <RefreshCw size={16} />
            </button>
            {/*  <button className='stock-view-btn' title='View Details'>
            <Eye size={16} />
          </button> */}
          </div>
        </td>
      </tr>
      {restockModal && <RestockOverlay refreshData={refreshData} product={product} closeModal={setRestockModal} warehouse={false} />}
    </>
  );
};

export const MobileProductCard = ({ updateSelectedProduct, viewStockDtails, product, refreshData, user }) => {
  const [restockModal, setRestockModal] = useState(false);
  const [quantity, setQuantity] = useState("");

  useEffect(() => {
    const quantityAvailable = computeProductQuantity(product);
    setQuantity(quantityAvailable);
  }, [product]);

  let placeholderImage = "https://res.cloudinary.com/ebuka1122/image/upload/v1746897856/static%20images%20storelens/download_bvjych.png";
  let imageUrl =
    product.productImage && product.productImage.length > 0
      ? `${product?.productImage[0]?.split("/upload/")[0]}/upload/f_auto,q_auto,w_56/${product.productImage[0].split("/upload/")[1]}`
      : placeholderImage;

  return (
    <>
      <div className='stock-mobile-item'>
        <div className='stock-mobile-header'>
          <div className='stock-mobile-image'>
            <img loading='lazy' className='stockImageSP' src={imageUrl ? imageUrl : ""} />
          </div>
          <div className='stock-mobile-title'>
            <h3 className='stock-mobile-name'>{product.name}</h3>
            <p className='stock-mobile-brand'>{product.brand}</p>
          </div>
          <div
            className={`stock-mobile-status ${
              product.quantity - product.damagedAmount <= product.stockLimit
                ? "stock-out-of-stock"
                : product.quantity - product.damagedAmount < 50
                ? "stock-low-stock"
                : "stock-in-stock"
            }`}
          >
            {product.damagedAmount ? (quantity - product.damagedAmount).toLocaleString() : quantity.toLocaleString()}
            {Number(product.quantity - product.damagedAmount) === 0 && <AlertTriangle size={14} />}
          </div>
        </div>

        <div className='stock-mobile-details'>
          <div className='stock-mobile-detail'>
            <span className='stock-mobile-detail-label'>Price</span>
            <span className='stock-mobile-detail-value'>
              {user.userCountryCurrencySymbol} {product.unitPrice.toLocaleString()}
            </span>
          </div>
          <div className='stock-mobile-detail'>
            <span className='stock-mobile-detail-label'>Sold</span>
            <span className='stock-mobile-detail-value'>{product.soldAmountAllTime ? product.soldAmountAllTime.toLocaleString() : 0}</span>
          </div>
          <div className='stock-mobile-detail'>
            <span className='stock-mobile-detail-label'>Discount</span>
            <span className='stock-mobile-detail-value'>
              {" "}
              {user.userCountryCurrencySymbol} {product.discountPrice ? product.discountPrice.toLocaleString() : 0}{" "}
              {product.discountPrice ? <FaPercentage size={12} /> : ""}
            </span>
          </div>
        </div>

        <div className='stock-mobile-actions'>
          <button onClick={() => setRestockModal(true)} className='stock-mobile-restock-btn'>
            <RefreshCw size={14} />
            Restock
          </button>
          <button
            onClick={() => {
              updateSelectedProduct(product);
              viewStockDtails("stockDetails");
            }}
            className='stock-mobile-view-btn'
          >
            <Eye size={14} />
            View
          </button>
        </div>
      </div>
      {restockModal && <RestockOverlay refreshData={refreshData} product={product} closeModal={setRestockModal} warehouse={false} />}
    </>
  );
};
